import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#1976d2', color: 'white', py: 3, textAlign: 'center' }}>
      <Typography variant="body1">&copy; Copyright (c) 2024 - Omnevu.com</Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        <Link
          href="/terms-and-privacy" // This should point to your blank HTML page or terms page
          target="_blank" // Opens the link in a new tab
          rel="noopener noreferrer"
          sx={{ color: 'white', textDecoration: 'underline' }}
        >
          Terms & Conditions and Privacy Policy
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
